// @ts-nocheck
export const OPEN_SMS_MODAL = "OPEN_SMS_MODAL";
export const CLOSE_SMS_MODAL = "CLOSE_SMS_MODAL";

// send sms
export const OPEN_SEND_SMS_MODAL = "OPEN_SEND_SMS_MODAL";
export const CLOSE_SEND_SMS_MODAL = "CLOSE_SEND_SMS_MODAL";
export const CLOSE_SEND_SMS_MODAL_WITH_HISTORY =
  "CLOSE_SEND_SMS_MODAL_WITH_HISTORY";

// open sms modal direct
export const OPEN_SEND_SMS_MODAL_DIRECT = "OPEN_SEND_SMS_MODAL_DIRECT";

// send sms action
export const SEND_SMS_REQUEST = "SEND_SMS_REQUEST";
export const SEND_SMS_SUCCESS = "SEND_SMS_SUCCESS";
export const SEND_SMS_FAILURE = "SEND_SMS_FAILURE";

// fetch people for sms
export const FETCH_PEOPLE_FOR_SMS_REQUEST = "FETCH_PEOPLE_FOR_SMS_REQUEST";
export const FETCH_PEOPLE_FOR_SMS_FAILURE = "FETCH_PEOPLE_FOR_SMS_FAILURE";
export const FETCH_PEOPLE_FOR_SMS_SUCCESS = "FETCH_PEOPLE_FOR_SMS_SUCCESS";

// open close report modal
export const OPEN_REPORT_MODAL = "OPEN_REPORT_MODAL";
export const CLOSE_REPORT_MODAL = "CLOSE_REPORT_MODAL";

// report request
export const REPORT_CONTRACTOR_REQUEST = "REPORT_CONTRACTOR_REQUEST";
export const REPORT_CONTRACTOR_SUCCESS = "REPORT_CONTRACTOR_SUCCESS";
export const REPORT_CONTRACTOR_FAILURE = "REPORT_CONTRACTOR_FAILURE";

// unflag request
export const UNFLAG_CONTRACTOR_REQUEST = "UNFLAG_CONTRACTOR_REQUEST";
export const UNFLAG_CONTRACTOR_SUCCESS = "UNFLAG_CONTRACTOR_SUCCESS";
export const UNFLAG_CONTRACTOR_FAILURE = "UNFLAG_CONTRACTOR_FAILURE";

// fetch older sms
export const FETCH_OLDER_SMS_REQUEST = "FETCH_OLDER_SMS_REQUEST";
export const FETCH_OLDER_SMS_FAILURE = "FETCH_OLDER_SMS_FAILURE";
export const FETCH_OLDER_SMS_SUCCESS = "FETCH_OLDER_SMS_SUCCESS";

// direct sms
export const OPEN_DIRECT_SMS_MODAL = "OPEN_DIRECT_SMS_MODAL";
export const CLOSE_DIRECT_SMS_MODAL = "CLOSE_DIRECT_SMS_MODAL";

// trigger sms for sms consent
export const TRIGGER_SMS_CONSENT_REQUEST = "TRIGGER_SMS_CONSENT_REQUEST";
export const TRIGGER_SMS_CONSENT_SUCCESS = "TRIGGER_SMS_CONSENT_SUCCESS";
export const TRIGGER_SMS_CONSENT_FAILURE = "TRIGGER_SMS_CONSENT_FAILURE";

// trigger consent for email
export const TRIGGER_EMAIL_CONSENT_REQUEST = "TRIGGER_EMAIL_CONSENT_REQUEST";
export const TRIGGER_EMAIL_CONSENT_SUCCESS = "TRIGGER_EMAIL_CONSENT_SUCCESS";
export const TRIGGER_EMAIL_CONSENT_FAILURE = "TRIGGER_EMAIL_CONSENT_FAILURE";

// restirct contractor
export const RESTRICT_CONTRACTOR_REQUEST = "RESTRICT_CONTRACTOR_REQUEST";
export const RESTRICT_CONTRACTOR_SUCCESS = "RESTRICT_CONTRACTOR_SUCCESS";
export const RESTRICT_CONTRACTOR_FAILURE = "RESTRICT_CONTRACTOR_FAILURE";

// unrestirct contractor
export const UNRESTRICT_CONTRACTOR_REQUEST = "UNRESTRICT_CONTRACTOR_REQUEST";
export const UNRESTRICT_CONTRACTOR_SUCCESS = "UNRESTRICT_CONTRACTOR_SUCCESS";
export const UNRESTRICT_CONTRACTOR_FAILURE = "UNRESTRICT_CONTRACTOR_FAILURE";